import { render } from "./App.vue?vue&type=template&id=615d9320&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./css/App.css?vue&type=style&index=0&id=615d9320&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=615d9320&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=2&id=615d9320&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Korisnik\\Desktop\\3. Semestar Mag\\VUI\\DiplomaInsight\\DiplomaInsight\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615d9320"]])

export default __exports__